/*
  90'S HOME – thư viện nút bấm cho landing page & trang sản phẩm.
  Dùng bằng thuộc tính HTML (không cần viết JS):

  1) Mua ngay (thẳng tới thanh toán Shopify, khuyến mãi tự áp dụng):
     <a data-nh-buy="HANDLE-SAN-PHAM" data-sku="DTM01A" data-qty="1">Mua ngay</a>
  2) Thêm vào giỏ (rồi mở giỏ hàng):
     <button data-nh-cart="HANDLE-SAN-PHAM" data-sku="DTM01A">Thêm vào giỏ</button>
  3) Đặt nhanh – mở khung nhỏ Tên + SĐT (đơn về Pancake POS):
     <button data-nh-quick="HANDLE-SAN-PHAM" data-sku="DTM01A">Đặt nhanh</button>
  4) Form đặt nhanh nằm sẵn trong trang (không cần bấm mở):
     <div data-nh-quick-form="HANDLE-SAN-PHAM"></div>

  data-sku / data-variant (ID loại) là tuỳ chọn – không có thì lấy loại đầu tiên còn hàng.
  Có thể thêm data-campaign="ten-chien-dich" để ghi chú nguồn đơn.
*/
(function () {
  if (window.__nhReady) return;
  window.__nhReady = true;

  var CFG = window.NH_CONFIG || {};
  var productCache = {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function money(cents) {
    return (Math.round(cents / 100)).toLocaleString('vi-VN') + '₫';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function params() {
    var out = {};
    try {
      new URLSearchParams(location.search).forEach(function (v, k) {
        if (/^(utm_|fbclid|ttclid|gclid)/.test(k)) out[k] = v;
      });
    } catch (e) {}
    return out;
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Không tìm thấy sản phẩm "' + handle + '"');
          return r.json();
        });
    }
    return productCache[handle];
  }

  function pickVariant(product, el) {
    var vid = el.getAttribute('data-variant');
    var sku = (el.getAttribute('data-sku') || '').trim().toLowerCase();
    var v = null;
    if (vid) v = product.variants.find(function (x) { return String(x.id) === String(vid); });
    if (!v && sku) v = product.variants.find(function (x) { return (x.sku || '').toLowerCase() === sku; });
    if (!v) v = product.variants.find(function (x) { return x.available; }) || product.variants[0];
    return v;
  }

  function qtyOf(el) {
    var q = parseInt(el.getAttribute('data-qty') || '1', 10);
    return q > 0 ? q : 1;
  }

  function busy(el, on) {
    if (on) { el.setAttribute('aria-busy', 'true'); el.style.opacity = '0.6'; el.style.pointerEvents = 'none'; }
    else { el.removeAttribute('aria-busy'); el.style.opacity = ''; el.style.pointerEvents = ''; }
  }

  /* ---------- Mua ngay: dùng đường dẫn giỏ hàng Shopify → thẳng tới thanh toán ---------- */
  function buyNow(el) {
    var handle = el.getAttribute('data-nh-buy');
    busy(el, true);
    getProduct(handle).then(function (p) {
      var v = pickVariant(p, el);
      var url = '/cart/' + v.id + ':' + qtyOf(el);
      var code = el.getAttribute('data-discount');
      if (code) url += '?discount=' + encodeURIComponent(code);
      track('InitiateCheckout', { value: v.price / 100 * qtyOf(el), currency: 'VND' });
      location.href = url;
    }).catch(function (err) { busy(el, false); alert(err.message); });
  }

  /* ---------- Thêm vào giỏ ---------- */
  function addToCart(el) {
    var handle = el.getAttribute('data-nh-cart');
    busy(el, true);
    getProduct(handle).then(function (p) {
      var v = pickVariant(p, el);
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qtyOf(el) }] })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        track('AddToCart', { value: v.price / 100 * qtyOf(el), currency: 'VND' });
        var icon = document.getElementById('cart-icon-bubble');
        if (document.querySelector('cart-drawer') && icon) { busy(el, false); location.reload(); }
        else location.href = '/cart';
      });
    }).catch(function (err) { busy(el, false); alert(err.message); });
  }

  /* ---------- Đặt nhanh ---------- */
  function formHTML(p, v, el) {
    var variants = p.variants.length > 1
      ? '<label class="nh-q__label">Chọn loại</label><select class="nh-q__input" name="variant">' +
        p.variants.map(function (x) {
          return '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + (x.available ? '' : ' disabled') + '>' +
            esc(x.title) + ' – ' + money(x.price) + (x.available ? '' : ' (hết hàng)') + '</option>';
        }).join('') + '</select>'
      : '<input type="hidden" name="variant" value="' + v.id + '">';
    return '' +
      '<form class="nh-q__form" novalidate>' +
        '<div class="nh-q__product">' +
          (p.featured_image ? '<img src="' + esc(p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '" alt="" width="64" height="64">' : '') +
          '<div><b>' + esc(p.title) + '</b><span class="nh-q__price" data-price>' + money(v.price) + '</span></div>' +
        '</div>' +
        variants +
        '<div class="nh-q__row">' +
          '<div><label class="nh-q__label">Số lượng</label>' +
            '<div class="nh-q__qty"><button type="button" data-d="-1" aria-label="Giảm">−</button>' +
            '<input name="qty" type="number" min="1" value="' + qtyOf(el) + '" inputmode="numeric">' +
            '<button type="button" data-d="1" aria-label="Tăng">+</button></div></div>' +
        '</div>' +
        '<label class="nh-q__label">Họ tên <span>*</span></label>' +
        '<input class="nh-q__input" name="name" autocomplete="name" placeholder="Ví dụ: Nguyễn Văn A" required>' +
        '<label class="nh-q__label">Số điện thoại <span>*</span></label>' +
        '<input class="nh-q__input" name="phone" type="tel" inputmode="tel" autocomplete="tel" placeholder="Ví dụ: 0912 345 678" required>' +
        '<input class="nh-q__hp" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
        '<p class="nh-q__err" role="alert" hidden></p>' +
        '<button type="submit" class="nh-q__submit">' + esc(CFG.submitLabel || 'Gửi – 90\'S HOME gọi lại ngay') + '</button>' +
        '<p class="nh-q__note">' + esc(CFG.note || '') + '</p>' +
      '</form>' +
      '<div class="nh-q__done" hidden>' +
        '<div class="nh-q__tick">✓</div>' +
        '<b>' + esc(CFG.successTitle || 'Đặt hàng thành công!') + '</b>' +
        '<p>' + esc(CFG.successText || '') + '</p>' +
      '</div>';
  }

  function wireForm(box, p, el) {
    var form = $('.nh-q__form', box);
    var err = $('.nh-q__err', box);
    var sel = form.querySelector('[name=variant]');
    var qty = form.querySelector('[name=qty]');
    function currentVariant() {
      var id = sel ? sel.value : form.querySelector('[name=variant]').value;
      return p.variants.find(function (x) { return String(x.id) === String(id); });
    }
    if (sel && sel.tagName === 'SELECT') sel.addEventListener('change', function () {
      $('[data-price]', form).textContent = money(currentVariant().price);
    });
    form.querySelectorAll('[data-d]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-d'), 10));
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameEl = form.querySelector('[name=name]');
      var phoneEl = form.querySelector('[name=phone]');
      var name = nameEl.value.trim();
      var phone = phoneEl.value.replace(/[\s.\-]/g, '');
      if (phone.indexOf('+84') === 0) phone = '0' + phone.slice(3);
      err.hidden = true;
      if (name.length < 2) { err.textContent = 'Bạn vui lòng nhập họ tên.'; err.hidden = false; nameEl.focus(); return; }
      if (!/^0\d{9}$/.test(phone)) { err.textContent = 'Số điện thoại chưa đúng (10 số, bắt đầu bằng 0).'; err.hidden = false; phoneEl.focus(); return; }
      if (!CFG.endpoint) { err.textContent = 'Chưa cài đặt nơi nhận đơn. Bạn vui lòng gọi/Zalo ' + (CFG.zalo || '') + '.'; err.hidden = false; return; }
      var v = currentVariant();
      var q = Math.max(1, parseInt(qty.value, 10) || 1);
      var payload = Object.assign({
        name: name,
        phone: phone,
        product: p.title,
        handle: p.handle,
        variant: v.title,
        variant_id: v.id,
        sku: v.sku || '',
        qty: q,
        price: v.price / 100,
        total: v.price / 100 * q,
        campaign: el.getAttribute('data-campaign') || '',
        page: location.href.split('#')[0],
        referrer: document.referrer || '',
        website: form.querySelector('[name=website]').value
      }, params());
      var btn = $('.nh-q__submit', form);
      btn.disabled = true;
      btn.textContent = 'Đang gửi…';
      fetch(CFG.endpoint, { method: 'POST', body: JSON.stringify(payload) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (!res || !res.ok) throw new Error((res && res.error) || 'Gửi chưa thành công');
          form.hidden = true;
          $('.nh-q__done', box).hidden = false;
          track('Lead', { value: payload.total, currency: 'VND', content_name: p.title });
          document.dispatchEvent(new CustomEvent('nh:lead', { detail: payload }));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = CFG.submitLabel || 'Gửi';
          err.textContent = 'Gửi chưa thành công. Bạn thử lại hoặc nhắn Zalo ' + (CFG.zalo || '') + ' nhé.';
          err.hidden = false;
        });
    });
  }

  function openQuick(el) {
    var handle = el.getAttribute('data-nh-quick');
    busy(el, true);
    getProduct(handle).then(function (p) {
      busy(el, false);
      /* Trên trang sản phẩm: lấy đúng loại khách đang chọn */
      var picked = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (!el.getAttribute('data-variant') && !el.getAttribute('data-sku') && picked) el.setAttribute('data-variant', picked.value);
      var qInput = document.querySelector('.product-form__quantity input[name="quantity"]');
      if (!el.getAttribute('data-qty') && qInput) el.setAttribute('data-qty', qInput.value);
      var v = pickVariant(p, el);
      var wrap = document.createElement('div');
      wrap.className = 'nh-q';
      wrap.innerHTML =
        '<div class="nh-q__backdrop" data-close></div>' +
        '<div class="nh-q__dialog" role="dialog" aria-modal="true" aria-label="Đặt hàng nhanh">' +
          '<button type="button" class="nh-q__close" data-close aria-label="Đóng">×</button>' +
          '<h3 class="nh-q__title">' + esc(CFG.title || 'Đặt hàng nhanh') + '</h3>' +
          '<p class="nh-q__sub">' + esc(CFG.subtitle || '') + '</p>' +
          '<div class="nh-q__body">' + formHTML(p, v, el) + '</div>' +
        '</div>';
      document.body.appendChild(wrap);
      document.documentElement.style.overflow = 'hidden';
      function close() { wrap.remove(); document.documentElement.style.overflow = ''; document.removeEventListener('keydown', onKey); }
      function onKey(e) { if (e.key === 'Escape') close(); }
      wrap.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', onKey);
      wireForm(wrap, p, el);
      setTimeout(function () { var n = wrap.querySelector('[name=name]'); n && n.focus(); }, 50);
    }).catch(function (err) { busy(el, false); alert(err.message); });
  }

  function mountInline(el) {
    if (el.dataset.nhMounted) return;
    el.dataset.nhMounted = '1';
    getProduct(el.getAttribute('data-nh-quick-form')).then(function (p) {
      var v = pickVariant(p, el);
      el.classList.add('nh-q', 'nh-q--inline');
      el.innerHTML = '<div class="nh-q__body">' + formHTML(p, v, el) + '</div>';
      wireForm(el, p, el);
    }).catch(function (err) { el.textContent = err.message; });
  }

  /* ---------- Đo lường quảng cáo (nếu trang có Meta/TikTok pixel) ---------- */
  function track(evt, data) {
    try { if (window.fbq) window.fbq('track', evt, data); } catch (e) {}
    try {
      var map = { Lead: 'SubmitForm', InitiateCheckout: 'InitiateCheckout', AddToCart: 'AddToCart' };
      if (window.ttq && map[evt]) window.ttq.track(map[evt], data);
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-nh-buy],[data-nh-cart],[data-nh-quick]');
    if (!el) return;
    e.preventDefault();
    if (el.hasAttribute('data-nh-buy')) buyNow(el);
    else if (el.hasAttribute('data-nh-cart')) addToCart(el);
    else openQuick(el);
  });

  function mountAll() { document.querySelectorAll('[data-nh-quick-form]').forEach(mountInline); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountAll);
  else mountAll();
})();
